import {UPDATE_FAQ} from '../mutationTypes';

export default {
  [UPDATE_FAQ](state, data) {
    state.faq = data || [];
  },
};
